import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export const getCategories = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/bodyAndMind/categories`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};


export const saveCategory = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/categories`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateCategory = async (payload, categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/categories/${categoryId}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const hideCategory = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/bodyAndMind/categories/${categoryId}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const showCategory = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/bodyAndMind/categories/restore/${categoryId}`, {}, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const reOrderCategory = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/bodyAndMind/categories/reorderCategories/`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const deleteCategory = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/bodyAndMind/categories/permanentDelete/${categoryId}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};
